// src/pages/FaqPublicResults/faqPublicResultsData.js

export const HELP_CATEGORIES = [
  { id: "visitor", label: "Visiteurs", tone: "blue" },
  { id: "organizer", label: "Organisateurs", tone: "indigo" },
  { id: "competition", label: "Gestion compétition", tone: "emerald" },
  { id: "combat", label: "Combats & score", tone: "violet" },
  { id: "media", label: "Médias", tone: "amber" },
];

export const HELP_SECTIONS = [
  {
    id: "resultats-publics",
    category: "visitor",
    title: "Résultats publics",
    eyebrow: "Visiteurs",
    icon: "🏆",
    summary:
      "Consulter les résultats publics, rechercher un club, voir les combats en cours et les podiums disponibles.",
    blocks: [
      {
        title: "Accès à la page",
        items: [
          "Depuis le menu de l’application : Application > Résultats Public.",
          "En scannant le QR Code fourni par l’organisateur, vous accédez directement aux résultats de la compétition concernée.",
        ],
      },
      {
        title: "Recherche de résultats",
        items: [
          "Par défaut, vous devez rechercher un club ou un compétiteur pour afficher les résultats pertinents.",
          "Les résultats terminés indiquent le classement, les victoires et les scores.",
          "Les combats en cours peuvent afficher le tapis concerné lorsque l’information est disponible.",
        ],
      },
      {
        title: "Photos des podiums",
        items: [
          "Si l’organisateur rend les photos publiques, vous pouvez consulter les photos de podiums par catégorie.",
          "L’affichage dépend des réglages choisis par l’organisateur.",
        ],
      },
    ],
  },
  {
    id: "reglements",
    category: "visitor",
    title: "Règlements arbitrage & commissaires sportifs",
    eyebrow: "Documentation",
    icon: "📘",
    summary:
      "Retrouvez les explications des règlements d’arbitrage et les informations utiles pour les commissaires sportifs.",
    blocks: [
      {
        title: "Contenu disponible",
        items: [
          "Des explications sur les différents règlements d’arbitrage sont mises à jour régulièrement.",
          "Les documents peuvent évoluer selon les disciplines et les catégories d’âge.",
        ],
      },
    ],
  },
  {
    id: "tableau-score",
    category: "combat",
    title: "Tableau de score",
    eyebrow: "Scoreboard",
    icon: "🥋",
    summary:
      "Utilisation du tableau de score Judo pour suivre et enregistrer les combats.",
    blocks: [
      {
        title: "Fonctionnement général",
        items: [
          "Le tableau de score permet de gérer les combats en temps réel.",
          "Il affiche les combattants rouge et blanc, le chrono principal, l’Osae Komi, les points, les pénalités et les forfaits.",
          "Il est possible de caster l’affichage sur un écran selon votre configuration.",
        ],
      },
    ],
  },
  {
    id: "mes-competitions",
    category: "organizer",
    title: "Mes compétitions",
    eyebrow: "Création & paramétrage",
    icon: "🗂️",
    summary:
      "Créer, modifier, publier et paramétrer une compétition.",
    blocks: [
      {
        title: "Création de compétitions",
        items: [
          "Une fois votre abonnement actif, vous pouvez créer une ou plusieurs compétitions.",
          "Le formulaire permet de renseigner le nom, la date, le niveau, le lieu, les horaires de pesées et la visibilité publique.",
        ],
      },
      {
        title: "Modification et suppression",
        items: [
          "Après création, vous pouvez modifier les informations principales de la compétition.",
          "La suppression d’une compétition supprime aussi les données associées : compétiteurs, résultats, répartitions, tapis et combats.",
          "Une double confirmation est recommandée pour éviter toute erreur.",
        ],
        warning:
          "Attention : une suppression de compétition est définitive. Vérifiez bien avant de confirmer.",
      },
      {
        title: "Options de compétition",
        items: [
          "Vous pouvez paramétrer des temps de combat différents selon les catégories d’âge.",
          "Vous pouvez activer ou désactiver certaines options : Waza-ari Awasete Ippon, fin après 1 ou 2 ippons, limite de points maximum.",
        ],
      },
      {
        title: "Invitations et QR Code",
        items: [
          "Un lien d’invitation permet aux clubs d’inscrire leurs compétiteurs.",
          "Les clubs peuvent modifier leurs inscriptions tant que les judokas ne sont pas marqués présents ou déjà engagés.",
          "Un QR Code est généré pour accéder rapidement à la page des résultats publics.",
        ],
      },
      {
        title: "QR Code d'inscription de compétiteurs",
        items: [
          "Un QR Code d’inscription est disponible pour chaque compétition.",
          "Il peut permettre à un compétiteur ou un club de s’inscrire rapidement en scannant le code avec un smartphone.",
          "Le QR Code d’inscription est différent du QR Code d’accès aux résultats publics.",
        ],
      },
    ],
  },
  {
    id: "pesees",
    category: "competition",
    title: "Pesées",
    eyebrow: "Présence & poids",
    icon: "⚖️",
    summary:
      "Gérer les compétiteurs présents, les poids et les données nécessaires aux répartitions.",
    blocks: [
      {
        title: "Alimenter le listing des compétiteurs",
        items: [
          "Ajout manuel d’un compétiteur : nom, prénom, date de naissance, licence, club, poids et genre.",
          "Import Excel depuis un export externe, en respectant le format des colonnes.",
          "Inscription via lien d’invitation envoyé aux clubs.",
        ],
      },
      {
        title: "Filtres disponibles",
        items: [
          "Filtre par nom.",
          "Filtre par présence ou absence.",
          "Filtre par genre.",
          "Filtre par catégorie d’âge.",
          "Filtre par année de naissance.",
          "Filtre par catégorie de poids.",
        ],
      },
      {
        title: "Poids et présence",
        items: [
          "Lorsqu’un poids est enregistré, le compétiteur est automatiquement marqué présent.",
          "Si le poids est déjà renseigné, il reste possible de modifier manuellement la présence.",
        ],
      },
      {
        title: "Édition et suppression",
        items: [
          "Vous pouvez modifier les informations d’un compétiteur depuis la page Pesées.",
          "La suppression d’un judoka déjà engagé peut entraîner la suppression des combats associés.",
        ],
        warning:
          "Supprimer un judoka engagé dans une poule peut impacter les combats déjà générés.",
      },
    ],
  },
  {
    id: "distributions",
    category: "competition",
    title: "Distributions / Répartitions en poules",
    eyebrow: "Poules",
    icon: "🧮",
    summary:
      "Créer des poules, sélectionner les judokas et affecter les répartitions aux tapis.",
    blocks: [
      {
        title: "Répartir les compétiteurs",
        items: [
          "Depuis la liste des compétiteurs présents et pesés, vous pouvez sélectionner entre 2 et 6 judokas.",
          "Vous choisissez ensuite une formule de poule et le tapis concerné.",
          "Une fois répartis, les compétiteurs sont grisés et ne sont plus sélectionnables.",
        ],
      },
      {
        title: "Contrôle des répartitions",
        items: [
          "Vous pouvez consulter le détail d’une répartition.",
          "Vous pouvez supprimer une répartition si besoin.",
          "Des filtres avancés permettent d’affiner la liste : genre, âge, année de naissance, poids.",
        ],
      },
    ],
  },
  {
    id: "tapis",
    category: "competition",
    title: "Tapis disponibles",
    eyebrow: "Organisation",
    icon: "🧩",
    summary:
      "Visualiser les tapis, les distributions affectées et accéder à la gestion des résultats.",
    blocks: [
      {
        title: "Vue par tapis",
        items: [
          "La page affiche les tapis disponibles pour la compétition.",
          "Chaque tapis affiche les distributions affectées.",
          "Chaque distribution indique le nombre de judokas et le nombre de combats prévus.",
          "En cliquant sur une carte tapis, vous accédez à la gestion des résultats du tapis.",
        ],
      },
    ],
  },
  {
    id: "suivi-combats",
    category: "combat",
    title: "Suivi des combats",
    eyebrow: "Gestion live",
    icon: "🎯",
    summary:
      "Sélectionner une poule, naviguer entre les combats et enregistrer les résultats.",
    blocks: [
      {
        title: "Sélection de la poule sur le tapis",
        items: [
          "Depuis la page de suivi, vous pouvez visualiser et sélectionner la poule à gérer.",
          "Vous pouvez alterner entre les différentes poules sans perte de données.",
          "En cliquant sur une poule, le tableau correspondant s’affiche pour saisir les résultats.",
        ],
      },
      {
        title: "Actions du tableau de poule",
        items: [
          "Imprimer le tableau de poule.",
          "Recharger les données.",
          "Afficher le classement final.",
          "Finaliser la distribution une fois tous les combats terminés.",
        ],
      },
      {
        title: "Sélecteur de combats",
        items: [
          "Le sélecteur de combats se trouve en bas du tableau de poule.",
          "Il est conseillé de respecter l’ordre des combats pour préserver les temps de repos.",
          "Les boutons bleus correspondent aux combats à venir.",
          "Les boutons verts correspondent aux combats déjà validés, mais modifiables si besoin.",
        ],
      },
      {
        title: "Enregistrement des résultats",
        items: [
          "À la fin du combat, une fenêtre permet de désigner le vainqueur.",
          "Une validation enregistre définitivement le combat.",
          "Le résultat apparaît ensuite dans le tableau de poule : V, D, N, F ou H.",
          "Le score en points est indiqué entre parenthèses et respecte le maximum défini dans les réglages.",
        ],
      },
    ],
  },
  {
    id: "resultats",
    category: "visitor",
    title: "Résultats",
    eyebrow: "Classements",
    icon: "🥇",
    summary:
      "Afficher les résultats finaux des distributions terminées.",
    blocks: [
      {
        title: "Résultats de compétition",
        items: [
          "La page affiche les résultats des compétiteurs pour les distributions terminées.",
          "Il est possible de filtrer par nom ou par club.",
          "Les résultats publics dépendent des réglages de visibilité de la compétition.",
        ],
      },
    ],
  },
  {
    id: "statistiques",
    category: "organizer",
    title: "Statistiques",
    eyebrow: "Analyse",
    icon: "📊",
    summary:
      "Consulter les statistiques générales de la compétition.",
    blocks: [
      {
        title: "Statistiques générales",
        items: [
          "Nombre de compétiteurs engagés et présents.",
          "Taux de présence.",
          "Répartition garçons / filles.",
          "Nombre de distributions créées.",
          "Nombre de combats réalisés.",
          "Nombre de clubs invités.",
          "Tableau détaillé par club : inscrits, présents et pourcentage de participation.",
        ],
      },
    ],
  },
  {
    id: "photos",
    category: "media",
    title: "Gestion des photos",
    eyebrow: "Médias",
    icon: "📷",
    summary:
      "Ajouter, modifier et publier les photos de la compétition.",
    blocks: [
      {
        title: "Gestion des photos",
        items: [
          "L’organisateur sélectionne une compétition puis renseigne l’URL de la photo.",
          "Une description peut être ajoutée.",
          "La photo peut être affichée sur la page publique de la compétition.",
          "Les photos peuvent être modifiées ou supprimées.",
        ],
      },
      {
        title: "Recommandation",
        items: [
          "Privilégiez des images optimisées pour éviter les ralentissements.",
          "Pour de nombreuses photos, utilisez un service spécialisé comme Cloudinary.",
        ],
        warning:
          "Des images trop lourdes peuvent ralentir fortement la page publique.",
      },
    ],
  },
];